import { createSelector } from 'reselect';

export const notifications = state => state.notifications;

export const getNotifications = createSelector(
  notifications,
  notifications => notifications
);
